import { render, staticRenderFns } from "./Trazabilidad_Harina.vue?vue&type=template&id=4f25aabe&scoped=true&"
import script from "./Trazabilidad_Harina.vue?vue&type=script&lang=js&"
export * from "./Trazabilidad_Harina.vue?vue&type=script&lang=js&"
import style0 from "./Trazabilidad_Harina.vue?vue&type=style&index=0&id=4f25aabe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f25aabe",
  null
  
)

export default component.exports